var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0252 5.1377C10.8877 5.1377 7.52523 8.5002 7.52523 12.6377V16.2502C7.52523 17.0127 7.20023 18.1752 6.81273 18.8252L5.37523 21.2127C4.48773 22.6877 5.10023 24.3252 6.72523 24.8752C12.1127 26.6752 17.9252 26.6752 23.3127 24.8752C24.8252 24.3752 25.4877 22.5877 24.6627 21.2127L23.2252 18.8252C22.8502 18.1752 22.5252 17.0127 22.5252 16.2502V12.6377C22.5252 8.5127 19.1502 5.1377 15.0252 5.1377Z",
    stroke: "#020607",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3374 5.4998C16.9499 5.3873 16.5499 5.2998 16.1374 5.2498C14.9374 5.0998 13.7874 5.1873 12.7124 5.4998C13.0749 4.5748 13.9749 3.9248 15.0249 3.9248C16.0749 3.9248 16.9749 4.5748 17.3374 5.4998Z",
    stroke: "#020607",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7749 25.3252C18.7749 27.3877 17.0874 29.0752 15.0249 29.0752C13.9999 29.0752 13.0499 28.6502 12.3749 27.9752C11.6999 27.3002 11.2749 26.3502 11.2749 25.3252",
    stroke: "#020607",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.69a6de1ff437ccadb0f8c6a701a0deaf.svg";
export { ForwardRef as ReactComponent };